'use client';

import dynamic from 'next/dynamic';

const SubscribeModal = dynamic(() => import('./SubscribeModal'), {
  ssr: false,
});

interface SubscribeModalPortalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SubscribeModalPortal({ isOpen, onClose }: SubscribeModalPortalProps) {
  return <SubscribeModal isOpen={isOpen} onClose={onClose} />;
}